const C = {
  name: "WebinarLive",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.25 10C13.25 10.6904 12.6904 11.25 12 11.25C11.3096 11.25 10.75 10.6904 10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10Z" fill="currentColor"/>
<path d="M12.0002 5C7.11016 5 5.16016 9.42 5.08016 9.61L4.91016 10L5.08016 10.39C5.16016 10.58 7.11016 15 12.0002 15C16.8902 15 18.8402 10.58 18.9202 10.39L19.0902 10L18.9202 9.61C18.8402 9.42 16.8902 5 12.0002 5ZM12.0002 13C9.15016 13 7.64016 10.9 7.12016 10C7.64016 9.11 9.16016 7 12.0002 7C14.8402 7 16.3602 9.1 16.8802 10C16.3602 10.89 14.8402 13 12.0002 13Z" fill="currentColor"/>
<path d="M20 5.25C20 5.94036 19.4404 6.5 18.75 6.5C18.0596 6.5 17.5 5.94036 17.5 5.25C17.5 4.55964 18.0596 4 18.75 4C19.4404 4 20 4.55964 20 5.25Z" fill="currentColor"/>
<path d="M20 1H4C2.35 1 1 2.35 1 4V16C1 17.65 2.35 19 4 19H20C21.65 19 23 17.65 23 16V4C23 2.35 21.65 1 20 1ZM21 16C21 16.55 20.55 17 20 17H4C3.45 17 3 16.55 3 16V4C3 3.45 3.45 3 4 3H20C20.55 3 21 3.45 21 4V16Z" fill="currentColor"/>
<path d="M17 23V21H7V23H17Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as WebinarLive
};
